module.exports = __webpack_public_path__ + "img/documento.77b7fab2.svg";